<template>
  <v-card width="100%" flat class="mt-auto">
    <v-divider />
    <div
      v-if="showDocuments"
      class="py-4 flex-wrap"
      :class="{ 'flex-column': column, 'd-flex': column }"
    >
      Useful Documents:
      <a class="mx-2" @click="downloadFile(cardholderAgreementFilename)">Cardholder Agreement</a>
      <span v-if="!column">|</span>
      <a class="mx-2" @click="downloadFile(issuingBankPrivacyFilename)">Bank Privacy Policy</a>
      <span v-if="!column">|</span>
      <a class="mx-2" @click="downloadFile(faqFilename)">FAQ</a>
    </div>
  </v-card>
</template>

<script>
import UserService from "@/services/UserService";
import isPaymentCardEnabled from "@/mixins/one10Points/isPaymentCardEnabled";
import taxInfoGateMixin from "@/mixins/taxInfoGate";
import {
  CARDHOLDER_AGREEMENT_FILENAME,
  FAQ_FILENAME,
  ISSUING_BANK_PRIVACY_FILENAME,
} from "@/constants/legalDocuments";

import { mapState } from "vuex";

export default {
  name: "MarqetaFooter",
  props: {
    column: Boolean,
  },
  mixins: [isPaymentCardEnabled, taxInfoGateMixin],
  components: {},
  data() {
    return {
      cardholderAgreementFilename: CARDHOLDER_AGREEMENT_FILENAME,
      issuingBankPrivacyFilename: ISSUING_BANK_PRIVACY_FILENAME,
      faqFilename: FAQ_FILENAME,
    };
  },
  created() {
    this.checkTaxInfoStatus();
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    downloadFile(fileName) {
      UserService.downloadCardProductFile(fileName, this.magicLinkToken);
    },
  },
  computed: {
    ...mapState(["userProfile", "magicLinkToken"]),
    // These documents describe a card the participant cannot have yet, so they
    // stay hidden until tax info is captured. Once it is - or where it is never
    // asked for - they are shown as before.
    showDocuments() {
      return this.isPaymentCardEnabled() && !this.showTaxInfoGate;
    },
  },
  watch: {},
};
</script>

<style scoped id="styles"></style>
